import React from 'react';
import { Link } from 'react-router-dom';
const linkStyle = { color: '#38a4dc', cursor: 'pointer', textDecoration: 'none' };

export const getColumns = [
  {
    title: 'Service Name',
    field: 'workflowName',
    headerStyle: { zIndex: 11 },
    width: '15%',
    render: (rowData: any) => {
      return (
        <Link to={`/service/${rowData.workflowCode}`} style={linkStyle}>
          {rowData.workflowName}
        </Link>
      );
    }
  },

  {
    title: 'Customers',
    field: 'customers',
    render: (rowData: any) => (rowData.customers ? rowData.customers : 0),
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Providers',
    field: 'providers',
    render: (rowData: any) => (rowData.providers ? rowData.providers : 0),
    headerStyle: { zIndex: 11 }
  },
  {
    title: '# of Errors Last Hour',
    field: 'lastHourErrorCount',
    headerStyle: { zIndex: 11 }
  },

  {
    title: '# of Errors Today',
    field: 'todayErrorCount',
    headerStyle: { zIndex: 11 }
  }
];

export default getColumns;
